import React from 'react';
import './NishPMC.css';

const NishPMC: React.FC = () => {
  const services = [
    {
      title: 'Fizibilite ve Stratejik Planlama',
      description: 'Her proje öncesinde, yatırımın ölçeğine ve ihtiyacına uygun detaylı fizibilite çalışmaları yapıyoruz. Bu sayede yatırımcıya net bir yol haritası sunuyor, olası riskleri daha başlamadan ortadan kaldırıyoruz.'
    },
    {
      title: 'Maliyet Kontrolü ve Bütçe Yönetimi',
      description: 'Yatırımcının en büyük kaygısı, projenin öngörülenden pahalıya mal olmasıdır. Nish P.M.C., şeffaf maliyet tabloları ve kontrol mekanizmalarıyla bütçeyi güvence altına alır. Her harcama kalemi önceden planlanır, sürpriz maliyetler ortadan kalkar.'
    },
    {
      title: 'Teknik Şartname ve Standartlar',
      description: 'Projelerin başarısı, kullanılan malzeme ve uygulamaların kalitesiyle doğru orantılıdır. Nish P.M.C. olarak uluslararası standartlara uygun teknik şartnameler hazırlar, tüm malzemelerin ve işçiliklerin bu standartlara göre seçilmesini sağlarız.'
    },
    {
      title: 'Proje Süreci ve Zaman Yönetimi',
      description: 'Her projenin en kritik unsurlarından biri de teslim süresidir. Doğru planlanmamış bir takvim, büyük maddi kayıplara yol açabilir. Biz, global tecrübemizle oluşturduğumuz zaman çizelgeleri sayesinde yatırımcının işini güvenle planlamasına olanak tanıyoruz.'
    },
    {
      title: 'Kalite Denetimi ve Süreç Kontrolü',
      description: 'Yalnızca planlama yapmakla kalmaz, uygulama sürecinde de sürekli denetim yaparız. Akustik panellerin montajından koltukların oturum testlerine kadar her adım Nish P.M.C. denetiminden geçer.'
    },
    {
      title: 'Sertifikasyon ve Uluslararası Uyum',
      description: 'Birçok ülkenin kendine özgü yangın güvenliği, akustik ve yapı standartları vardır. Nish P.M.C., 32 ülkedeki tecrübesiyle projeleri bu regülasyonlara uygun hale getirir, yatırımcıyı olası yasal risklerden korur.'
    }
  ];

  const advantages = [
    {
      title: 'Risklerin azaltılması',
      description: 'Tüm teknik ve finansal riskleri önceden analiz ederiz.'
    },
    {
      title: 'Zamanında teslim',
      description: 'Gecikmelerin önüne geçerek yatırımın planlanan tarihte açılmasını sağlarız.'
    },
    {
      title: 'Kaynakların verimli kullanımı',
      description: 'Gereksiz masrafları önler, bütçeyi en verimli şekilde kullanırız.'
    },
    {
      title: 'Güvenilir yol arkadaşlığı',
      description: 'Yatırımcı her adımda yalnız değil, profesyonel bir ekiple hareket eder.'
    }
  ];

  return (
    <div className="nish-pmc-page">
      <div className="page-container">
        <div className="page-header">
          <h1>Nish P.M.C.</h1>
          <h2>Proje Yönetimi ve Danışmanlık Hizmetleri</h2>
        </div>

        <div className="intro-section">
          <div className="intro-content">
            <p>
              Bir konferans veya sinema salonu projesi, yalnızca teknik bir inşaat süreci değildir. 
              Bu projeler; mimari tasarım, akustik planlama, oturma düzeni, ses-ışık-görüntü sistemleri, 
              yangın ve güvenlik standartları, bütçe ve zaman yönetimi gibi birçok bileşenin bir araya 
              gelmesiyle hayat bulur. Tüm bu karmaşık süreci tek başına yönetmeye çalışan yatırımcılar 
              için riskler artar, maliyetler yükselir ve zaman kayıpları yaşanır.
            </p>
            <p>
              Nish P.M.C. (Project Management & Consultancy) işte tam bu noktada devreye girer. 
              Yatırımcının yanında duran, projeyi baştan sona planlayan, yöneten ve denetleyen 
              profesyonel bir çözüm ortağıdır.
            </p>
          </div>
          <div className="intro-image">
            <img 
              src="https://static.wixstatic.com/media/11062b_b0ef0b74578f466ca4f12014956da9d0~mv2.jpeg/v1/crop/x_0,y_682,w_6720,h_3145/fill/w_1200,h_600,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Industrial%20Engineer.jpeg" 
              alt="Industrial Engineer"
            />
          </div>
        </div>

        <section className="services-section">
          <h2>Hizmet Kapsamımız</h2>
          <div className="services-list">
            {services.map((service, index) => (
              <div key={index} className="service-item">
                <h3>{index + 1}. {service.title}</h3>
                <p>{service.description}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="advantages-section">
          <h2>Yatırımcıya Sağladığımız Avantajlar</h2>
          <div className="advantages-content">
            <div className="advantages-image">
              <img 
                src="https://static.wixstatic.com/media/11062b_7ce95b72076f4b4a8a6a8116ef66e0e5~mv2.jpeg/v1/crop/x_0,y_12,w_6880,h_3220/fill/w_1200,h_600,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Engineers%20and%20Businesspeople.jpeg" 
                alt="Engineers and Businesspeople"
              />
            </div>
            <div className="advantages-list">
              {advantages.map((advantage, index) => (
                <div key={index} className="advantage-item">
                  <h3>→ {advantage.title}</h3>
                  <p>{advantage.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="why-section">
          <div className="why-content">
            <div className="why-text">
              <h2>Neden Nish P.M.C.</h2>
              <p>
                Çünkü biz yalnızca danışman değil, aynı zamanda yatırımcının stratejik ortağıyız. 
                Yıllara dayanan uluslararası tecrübemiz, teknik bilgimiz ve Türk mühendisliğinin 
                gücüyle, projelerinizi yalnızca tamamlamakla kalmıyor; onları dünya standartlarının 
                üzerine çıkarıyoruz.
              </p>
              <p>
                Bugün Orta Doğu'dan Orta Asya'ya, Avrupa'dan Afrika'ya kadar birçok ülkede tamamlanan 
                projelerimizle, Nish P.M.C. yatırımcıya güven, şeffaflık ve prestij kazandırmaktadır.
              </p>
            </div>
            <div className="why-image">
              <img 
                src="https://static.wixstatic.com/media/ee68f08f77854dac8c21bcc9ce161084.jpg/v1/crop/x_0,y_1115,w_5616,h_2628/fill/w_1200,h_600,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Bricks%20and%20Mortar.jpg" 
                alt="Bricks and Mortar"
              />
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default NishPMC;
